import { z } from 'zod'

export const stepCreateAccountSchema = z.object({
	accountName: z
		.string()
		.min(3, 'Account name must be at least 3 characters')
		.max(64, 'Account name must be at most 64 characters'),
	referralCode: z
		.string()
		.trim()
		.max(20, 'Referral codes are 10 characters long')
		.optional()
		.or(z.literal('')),
})

export type StepCreateAccountValues = z.infer<typeof stepCreateAccountSchema>
